import { render, staticRenderFns } from "./EdudashInput.vue?vue&type=template&id=fdb7b8a8&scoped=true&"
import script from "./EdudashInput.vue?vue&type=script&lang=js&"
export * from "./EdudashInput.vue?vue&type=script&lang=js&"
import style0 from "./EdudashInput.vue?vue&type=style&index=0&id=fdb7b8a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb7b8a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
